import _ from 'lodash';

function flattenArray(tree, childrenKey) {

    let flat = [];

    for (const i in tree) {

        let children = false;

        if (tree[i][childrenKey] !== undefined) {
            children = [...tree[i][childrenKey]];
            delete (tree[i][childrenKey])
        }

        flat.push(tree[i]);

        if (children) {
            flat = flat.concat(flattenArray(children, childrenKey));
        }

    }

    return flat
}

export class FilterTranslator {
    constructor(filter) {
        this.filter = filter;
        this.label = filter.label;
        this.filterType = filter.component.split("-")[0];
        this.data = filter.data;
        this.inputs = filter.inputs;
    }

    translate() {
        const firstLetter = "" + this.filterType[0];
        const functionName = `translate${firstLetter.toUpperCase()}${this.filterType.substring(1)}`;


        if (typeof this[functionName] !== "function") {
            return "";
        }

        return this[functionName]();
    }

    translateText() {
        const mode = this.getMode();

        if(!mode){
            return `${this.label} (${window.i18n.__('non applicable')})`
        }

        let translation = `${this.label} ${this.getModeLabel()}`;

        if (mode.value != "unknown" && mode.value != "known") {
            translation += ` "${this.data.value}"`;
        }

        return translation;
    }

    translateBoolean() {
        return `${this.label} : ${this.inputs.value.options[this.data.value].label}`;
    }

    getMode() {
        if (this.data.mode == undefined) {
            return false;
        }

        if(this.inputs.mode.options[this.data.mode] == undefined){
            return false;
        }

        return this.inputs.mode.options[this.data.mode];
    }

    getModeLabel() {
        return this.getMode().label.toLowerCase();
    }

    translateDate() {
        const mode = this.getMode();
        let dateValue = "";

        switch (mode.value) {
            case "smartdate":
                dateValue = this.inputs.smartdate.options[this.data.smartdate].label.toLowerCase();
                break;
            case "equals":
            case "before":
            case "after":
                const date = new Date(this.data.start);
                dateValue = date.toLocaleDateString();
                break;
            case "between":
                const start    = new Date(this.data.start);
                const end      = new Date(this.data.end);

                dateValue = window.i18n.__(
                    "entre le %(start)s et le %(end)s",
                    {
                        'start': start.toLocaleDateString(),
                        'end': end.toLocaleDateString(),
                    })
                break;
        }

        return `${this.label} ${this.getModeLabel()} ${dateValue}`.trim();
    }

    translateCheckbox() {
        var values = [];
            
        var modes = this.inputs.mode.options;
        var options = Object.values(this.inputs.choices.options);

        if(this.data.mode != undefined && this.data.mode != 'is'){
            const modevalue = modes[this.data.mode].label;
            return `${this.label}  ${modevalue}`;
        }

        if (typeof this.inputs.choices.options === 'object'){
            options = Object.values(this.inputs.choices.options);
        } else {
            options = [...this.inputs.choices.options];
        }

        for (const choiceIndex in this.data.choices){
            const index = _.findIndex(options, { 'value': this.data.choices[choiceIndex] });;

            if (index != -1) {
                values.push(options[index].label);
            }
        }

        return `${this.label}  ${values.join(", ")}`;
    }
           
    translateCheckbox2lvl() {

        var values = [];
        var subValues = [];
        var options = { ...this.inputs.choices.options };

        let nbChoices = 0;
        let nbSubChoices = 0;

        for(const ind in options){

            if(this.data.choices.includes(''+options[ind].value)){
                nbChoices += 1;
            }

            for(const subInd in {...options[ind].options}){
                if (this.data.subChoices.includes(options[ind].options[subInd].value)){
                    nbSubChoices += 1;
                }
            }
        }

        if(typeof this.label !== 'string'){
            return nbChoices +' '+ (nbChoices > 1 ? this.label[1] : this.label[0])
                        +' - '
                        +nbSubChoices+' '+ (nbSubChoices > 1 ? this.filter.label2[1] : this.filter.label2[0])
        }else{
            return nbChoices +' '+ this.label + " - " + nbSubChoices + " "+this.filter.label2;
        }

    }

    translateSelect() {
        var values = [];
        var options = { ...this.inputs.choice.options };

        if (typeof this.data.choice === Array || typeof this.data.choice === 'object'){
            for (const choiceIndex in this.data.choice) {
                const choice = this.data.choice[choiceIndex];
    
                if (options[choice] != undefined) {
                    values.push(options[choice].label);
                }
            }
        } else {
            const choice = this.data.choice

            if (options[choice] != undefined) {
                values.push(options[choice].label);
            }
        }

        return `${this.label} : ${values.join(", ")}`;
    }

    translateRadio() {
        var value = '';
        var options = { ...this.inputs.choice.options };

        if (options[this.data.choice] != undefined){
            value = options[this.data.choice].label;
        } else if (undefined !== Object.values(options).find(one => one.value == this.data.choice)) {
            value = Object.values(options).find(one => one.value == this.data.choice).label
        } else if ("" !== this.data.choice) {
            value = ': ' + window.i18n.__('valeur supprimée');
        }

        return `${this.label} ${value}`;
    }

    translateTag() {
        const mode = this.getMode();
        const tags = [];

        if (_.indexOf(["or", "and", "only", "neither", "not-either"], mode.value) != -1) {
            for (const tag of this.data.value) {
                tags.push(tag.name);
            }
        }

        return this.getModeLabel() + (tags.length ? " : " + tags.join(",") : "");
    }

    translateRange() {
               
        const mode = this.getMode();
        let value = "";

        if(!mode){
            return `${this.label} (${window.i18n.__('non applicable')})`
        }

        switch (mode.value) {
            case "lesser":
                value = window.i18n.__(
                    "Inférieur à %(value)s",
                    {
                        value: this.data.min
                    }
                );
                break;
            case "lesserequal":
                value = window.i18n.__(
                    "Inférieur ou égal à %(value)s",
                    {
                        value: this.data.min
                    }
                );
                break;
            case "greater":
                value = window.i18n.__(
                    "Supérieur à %(value)s",
                    {
                        value: this.data.min
                    }
                );
                break;
            case "greaterequal":
                value = window.i18n.__(
                    "Supérieur ou égal à %(value)s",
                    {
                        value: this.data.min
                    }
                );
                break;
            case "equals":
                value = window.i18n.__(
                    "à {value}",
                    {
                        value: this.data.min
                    }
                );
                break;
            case "between":
                value = window.i18n.__(
                    "entre %(min)s et %(max)s",
                    { ...this.data }
                );

                break;
        }
        return `${this.label} ${this.getModeLabel()} ${value}`.trim();
    }

    translateRgpd() {
        const level = this.inputs.level.options[this.data.level];
        const consent = this.inputs.consent.options[this.data.consent];

        let campaign = "";
        if (level.value == "subscribed") {
            campaign = window.i18n.__('aux campagnes');
        } else {
            campaign = window.i18n.__("des campagnes");
        }

        const campaigns = [];
        for (const campaign of this.data.campaigns) {
            if (typeof campaign === "string") {
                campaigns.push(this.inputs.campaigns.options[campaign].label.toLowerCase());
            }
        }

        return `${level.label} ${campaign} ${campaigns.join(", ")} ${consent.label.toLowerCase()}`;
    }

    translateAutocomplete() {
        const mode = this.getMode();
        const items = [];

        if (_.indexOf(["contain", "dontcontain"], mode.value) != -1) {
            for(const item of this.data.choices){
                items.push(item.name);
            }
        }

        return `${this.label} ${this.getModeLabel()}` + (items.length ? " " + items.join(", ") : "");
    }

    translateLocation(){
        const country = _.find(this.inputs.country.options, {value: this.data.country});

        let valueLabel = this.data.value;
        if(typeof this.data.value === Array){
            valueLabel = this.data.value.join(" "+window.i18n.__("ou")+" ");
        }

        return `${this.inputs.country.label} : ${country.name} / ${this.label} ${this.getModeLabel()} ${valueLabel}`;
    }


    translateRecursivecheckbox(){

        var options = flattenArray(this.inputs.choices.options, 'children')
        var values = [];
                
        for (const choiceIndex in this.data.choices) {
            const choice = this.data.choices[choiceIndex];

            const opt = _.find(options, {'id': choice}) 

            if (opt  != -1) {
                values.push(opt.name);
            }
        }


        return `${this.label} : `+values.join(', ');
    }
}